import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { TextInput, type TextInputProps } from '@interxfi/design-system/components/input/text-input/text-input';

interface PropsWithLens extends Omit<TextInputProps, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<string>;
}

export function AppTextInputWithLens({ onChange, shouldUnregister, lens, ...props }: PropsWithLens) {
  const { field, fieldState } = useController({ shouldUnregister, ...lens.interop() });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [onChange, fieldOnChange],
  );

  return (
    <TextInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={field.value || ''}
    />
  );
}
